<template>
  <div>
    <v-checkbox label="Assina CCB" v-model="assinaCCB" @change="retiraPapeis" v-if="!!nomeConjuge" />
    <input-multiselect v-model="model" :options="papeis" label="Papéis" :required="!nomeConjuge || assinaCCB" :disabled="!assinaCCB && !!nomeConjuge" />
  </div>
</template>
<script>
export default {
  props: {
    codigoProposta: String,
    value: [],
    assinante: Object,
    nomeConjuge: String,
    cliente: Object,
    tipoCCB: String
  },
  data () {
    return {
      listBase: [],
      assinaCCB: false,
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    papeis: {
      get () {
        if (!Array.isArray(this.$param.EST_PAPEIS)) {
          return [];
        }
        return this.$param.EST_PAPEIS.filter(el => {
          const tipo = this.$api.UI.Format.SomenteNumeros(this.cliente.DocumentoFederal).length === 11 ? 'pf' : 'pj';
          return el[tipo];
        }).map(el => ({
          text: el.papel,
          value: { Descricao: el.papel, PapelID: el.tipo },
        }));
      },
      set () {
        return this.$param.EST_PAPEIS;
      }
    }
  },
  methods: {
    submit () {
      const th = this;
      const nomeConjuge = th.nomeConjuge
      const assinanteDto = th.assinante
      if (!th.assinaCCB) {
        th.model = []
      }

      let arrayInclusao = Array.isArray(th.model) ? [...th.model] : [];
      let arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      if (arrayExclusao.length > 0) {
        arrayExclusao = arrayExclusao.map(papel => {
          return papel.Codigo
        })

        th.$api.Multiplo.Post('RemoveCCBDigitalAssinaturas', { dto: arrayExclusao }).then(resExclude => {
          if (th.$api.UI.PostLoadData(resExclude, true)) { };
        });
      }

      if (arrayInclusao.length > 0) {
        th.$api.Multiplo.Post('FindRecordProdutoRede').then(function (res) {
          arrayInclusao = arrayInclusao.map(papel => {
            return {
              CodigoProposta: th.codigoProposta,
              Nome: nomeConjuge
                ? `${assinanteDto.Nome} - CÔNJUGE DE ${nomeConjuge}`
                : assinanteDto.Nome,
              Email: assinanteDto.Email,
              Documento: assinanteDto.DocumentoFederal,
              TelefoneCelular: assinanteDto.TelefoneCelular,
              Descricao: papel.Descricao || '',
              PapelID: papel.PapelID === th.$aux.PapelAssinaturaEnum.Avalista ? papel.PapelID : null,
              NotificarPorEmail: th.tipoCCB !== 'C' && th.$aux.NotificaPorEmail.includes(res.ModeloNotificacaoAssinatura),
              NotificarPorWhatsApp: th.tipoCCB !== 'C' && th.$aux.NotificaPorWhatsApp.includes(res.ModeloNotificacaoAssinatura)
            }
          })

          th.$api.Multiplo.Post('InsertCCBDigitalAssinaturas', { dto: arrayInclusao }).then(resInsert => {
            if (th.$api.UI.PostLoadData(resInsert, true)) { };
          });
        })
      }
    },
    carregarAssinantes () {
      const th = this;
      const dtoAssinantes = {
        parameters: [
          { name: 'CodigoProposta', value: th.codigoProposta },
          { name: 'search', value: '' },
        ],
      };

      th.$api.Multiplo.Post('ListCCBDigitalAssinatura', dtoAssinantes).then(assinantes => {
        if (th.$api.UI.PostLoadData(assinantes)) {
          th.$set(th, 'listBase', assinantes.Data.filter(el => el.Documento === th.$api.UI.Format.SomenteNumeros(th.assinante.DocumentoFederal)));
          th.model = th.listBase.map((item) => { return { Descricao: item.Descricao, PapelID: !item.PapelID ? 3 : item.PapelID } });
          if (th.listBase.length > 0) th.assinaCCB = true;
        }
      });
    },
    retiraPapeis () {
      const th = this;
      if (!th.assinaCCB) {
        th.model = {}
      } else {
        th.model = th.listBase.map((item) => { return { Descricao: item.Descricao, PapelID: item.PapelID } });
      }
    }
  },
}
</script>
<style scoped>
</style>
